import React from 'react'
import { Link } from '../../../Link'

export const ProductBox = ({ url, title, description, moreInfoUrl, productImage }) => (
  <div className="col-md-6">
    <div className="icon-box" style={{ minHeight: 220 }}>
      <i>{productImage}</i>
      <h4>
        <a href={url}>{title}</a>
      </h4>
      <p>{description}</p>

      <Link reloadDocument to={moreInfoUrl} className="animate__animated animate__fadeInUp scrollto">
        More info...
      </Link>
    </div>
  </div>
)
